import request from '../utils/request'

export default {
  async lists(data) { // 获取协议列表
    const ret = await request('/v1/deviceProtocol/lists', data, 'POST')
    return ret
  },

  async selectList(data) { // 获取协议下拉列表
    const ret = await request('/v1/deviceProtocol/selectList', data, 'POST')
    return ret
  },

  async operate(data) { // 添加/编辑协议
    const ret = await request('/v1/deviceProtocol/operate', data, 'POST')
    return ret
  },

  async delete(data) { // 删除协议
    const ret = await request('/v1/deviceProtocol/delete', data, 'POST')
    return ret
  },

  async detail(data) { // 协议详情
    const ret = await request('/v1/deviceProtocol/detail', data, 'POST')
    return ret
  },

  async configOptions(data) { // 获取配置选项
    const ret = await request('/v1/deviceProtocol/configOptions', data, 'POST')
    return ret
  },

  async batchMenuOptions(data) { // 获取批量设置菜单配置
    const ret = await request('/v1/deviceProtocol/batchMenuOptions', data, 'POST')
    return ret
  }
}
